(() => {
  function updateBundleContents(root, variantId) {
    if (!root || !variantId) return;

    const lists = root.querySelectorAll('[data-bundle-variant-list]');
    let hasMatchingList = false;

    lists.forEach((list) => {
      const isMatchingList = list.dataset.bundleVariantList === String(variantId);
      list.classList.toggle('is-hidden', !isMatchingList);

      if (isMatchingList) {
        hasMatchingList = true;
      }
    });

    if (hasMatchingList || lists.length === 0) return;

    lists.forEach((list, index) => {
      list.classList.toggle('is-hidden', index !== 0);
    });
  }

  function initBundleContents() {
    document.querySelectorAll('[data-product-bundle-contents]').forEach((root) => {
      if (root.dataset.bundleContentsInitialized === 'true') return;

      root.dataset.bundleContentsInitialized = 'true';

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== root.dataset.sectionId) return;

          updateBundleContents(root, event.data.variant?.id);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleContents);
  } else {
    initBundleContents();
  }
})();
